import axiosInstance from '../config/axiosConfig';

/**
 * Service API simplifié qui exporte l'instance axios configurée.
 * Ce fichier est créé pour maintenir la compatibilité avec le code existant
 * qui importe apiService.
 */

// Exporter directement l'instance axios configurée
export default axiosInstance;
